import { render, staticRenderFns } from "./starRatingMiniFive.vue?vue&type=template&id=bdd91134&scoped=true"
import script from "./starRatingMiniFive.vue?vue&type=script&lang=js"
export * from "./starRatingMiniFive.vue?vue&type=script&lang=js"
import style0 from "./starRatingMiniFive.vue?vue&type=style&index=0&id=bdd91134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd91134",
  null
  
)

export default component.exports